import { render, staticRenderFns } from "./EventArea.vue?vue&type=template&id=ce77f2a4&scoped=true&"
import script from "./EventArea.vue?vue&type=script&lang=ts&"
export * from "./EventArea.vue?vue&type=script&lang=ts&"
import style0 from "./EventArea.vue?vue&type=style&index=0&id=ce77f2a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce77f2a4",
  null
  
)

export default component.exports